"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es7.object.get-own-property-descriptors");
require("core-js/modules/es6.object.keys");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.array.find");
var _defineProperty2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es7.string.pad-start");
var _interfaceLog = require("@/api/log/interfaceLog");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'interfaceLog',
  data: function data() {
    return {
      loading: false,
      logList: [],
      total: 0,
      queryParams: {
        page: 1,
        limit: 10,
        type: null,
        status: null,
        startTime: null,
        endTime: null
      },
      dateRange: [],
      detailVisible: false,
      detailTitle: '接口日志详情',
      logDetail: {},
      enumTypes: [],
      typeMap: {}
    };
  },
  created: function created() {
    this.getEnumType();
    this.setDefaultDateRange();
    this.getList();
  },
  methods: {
    setDefaultDateRange: function setDefaultDateRange() {
      var endDate = new Date();
      var startDate = new Date();
      startDate.setMonth(startDate.getMonth() - 1);
      var formatDate = function formatDate(date) {
        var year = date.getFullYear();
        var month = String(date.getMonth() + 1).padStart(2, '0');
        var day = String(date.getDate()).padStart(2, '0');
        var hours = String(date.getHours()).padStart(2, '0');
        var minutes = String(date.getMinutes()).padStart(2, '0');
        var seconds = String(date.getSeconds()).padStart(2, '0');
        return "".concat(year, "-").concat(month, "-").concat(day, " ").concat(hours, ":").concat(minutes, ":").concat(seconds);
      };
      this.dateRange = [formatDate(startDate), formatDate(endDate)];
    },
    getEnumType: function getEnumType() {
      var _this = this;
      (0, _interfaceLog.getEnumType)().then(function (response) {
        _this.enumTypes = response.data;
        _this.buildTypeMap();
      });
    },
    buildTypeMap: function buildTypeMap() {
      var _this2 = this;
      this.typeMap = {};
      this.enumTypes.forEach(function (item) {
        _this2.typeMap[item.type] = item.typeName;
      });
    },
    getList: function getList() {
      var _this3 = this;
      this.loading = true;
      var params = _objectSpread({}, this.queryParams);
      if (this.dateRange && this.dateRange.length === 2) {
        params.startTime = this.dateRange[0];
        params.endTime = this.dateRange[1];
      }
      (0, _interfaceLog.getInterfaceLogList)(params).then(function (response) {
        _this3.logList = response.records || [];
        _this3.total = response.total || 0;
        _this3.loading = false;
      }).catch(function () {
        _this3.loading = false;
      });
    },
    handleQuery: function handleQuery() {
      this.queryParams.page = 1;
      this.getList();
    },
    resetQuery: function resetQuery() {
      this.queryParams = {
        page: 1,
        limit: 10,
        type: null,
        status: null,
        startTime: null,
        endTime: null
      };
      this.dateRange = [];
      this.getList();
    },
    handleSizeChange: function handleSizeChange(size) {
      this.queryParams.limit = size;
      this.getList();
    },
    handleCurrentChange: function handleCurrentChange(current) {
      this.queryParams.page = current;
      this.getList();
    },
    handleDetail: function handleDetail(id) {
      var detail = this.logList.find(function (item) {
        return item.id === id;
      });
      if (detail) {
        this.logDetail = _objectSpread({}, detail);
        this.detailVisible = true;
      }
    },
    getTypeName: function getTypeName(type) {
      return this.typeMap[type] || type;
    },
    getStatusTagType: function getStatusTagType(status) {
      return status === 1 ? 'success' : 'danger';
    },
    getStatusText: function getStatusText(status) {
      return status === 1 ? '成功' : '失败';
    },
    formatDateTime: function formatDateTime(date) {
      if (!date) return '';
      var d = new Date(date);
      var year = d.getFullYear();
      var month = String(d.getMonth() + 1).padStart(2, '0');
      var day = String(d.getDate()).padStart(2, '0');
      var hours = String(d.getHours()).padStart(2, '0');
      var minutes = String(d.getMinutes()).padStart(2, '0');
      var seconds = String(d.getSeconds()).padStart(2, '0');
      return "".concat(year, "-").concat(month, "-").concat(day, " ").concat(hours, ":").concat(minutes, ":").concat(seconds);
    }
  }
};